class BaseResponse {
    constructor(responseCode = 500) {
        this.responseCode = responseCode
        this.isSuccess = responseCode === 200
    }
}

export default BaseResponse
